import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  validatePassword,
  validateEmail,
  updateMe,
  updateSetting,
} from '../helpers/api';

import {
  SETTINGS_CHANGE_SUCCESS,
  settingsChangeSuccess,
  settingsChangeFail,
  UPDATE_SUBSCRIPTION_SETTING_REQUEST,
  updateSubscriptionSetting,
} from '../actions/settings';

import { promptToast } from '../../../../components/toast-container/actions';

import { USERNAME_CHANGE } from '../actions/username';

import { DISPLAY_NAME_CHANGE, setDisplayName } from '../actions/display-name';

import { EMAIL_CHANGE } from '../actions/email';

import { PASSWORD_CHANGE } from '../actions/password';
import { graphql } from '../../../../globals/api/requests';
import updateSubscriptionSettingMutation from '../components/subscription-settings/update-subscription-setting-mutation.graphql';

export function* handleSettingsAction(action) {
  switch (action.type) {
    case PASSWORD_CHANGE: {
      try {
        const validate = yield call(validatePassword, action.newPassword);

        if (validate.error?.length) {
          throw new Error(
            validate.error[0].code ?? response.errors[0].extensions?.code
          );
        }

        const response = yield call(updateMe, {
          currentPassword: action.currentPassword,
          newPassword: action.newPassword,
        });

        if (response.errors?.length) {
          throw new Error(
            response.errors[0].code ?? response.errors[0].extensions?.code
          );
        }

        yield put(
          promptToast(
            'success',
            window.APP_GLOBALS.t('account', 'settings.saved')
          )
        );
        yield put(settingsChangeSuccess(response.data.updateMe));
      } catch (e) {
        yield put(
          settingsChangeFail({
            settings: action,
            error: e.message,
          })
        );
      }
      break;
    }

    case EMAIL_CHANGE: {
      try {
        const validate = yield call(validateEmail, action.email);

        if (validate.error?.length) {
          throw new Error(
            validate.error[0].code ?? response.errors[0].extensions?.code
          );
        }

        const response = yield call(updateMe, {
          email: action.email,
        });

        if (response.errors?.length) {
          throw new Error(
            response.errors[0].code ?? response.errors[0].extensions?.code
          );
        }

        if (!response.data.updateMe.changeEmailConfirmationSent) {
          throw new Error('registration.verification-mail-not-sent');
        }

        // @TODO: Save email in session for display on confirm page
        yield call(
          window.__history.push,
          '/account/settings/email-change/confirm'
        );

        // This needs to be here to make sure we're not leaving in a weird state.
        // Otherwise we're leaving it in a "saving" state,
        // meaning if the user returns to the settings page it will look like email setting still is trying to save.
        yield put(settingsChangeSuccess(action));
      } catch (e) {
        yield put(
          settingsChangeFail({
            settings: action,
            error: e.message,
          })
        );
      }
      break;
    }

    case DISPLAY_NAME_CHANGE: {
      try {
        const response = yield call(
          updateSetting,
          'display_name',
          action.displayName
        );

        if (response.errors?.length) {
          throw new Error(
            response.errors[0].code ?? response.errors[0].extensions?.code
          );
        }

        yield put(
          promptToast(
            'success',
            window.APP_GLOBALS.t('account', 'settings.saved')
          )
        );

        yield put(setDisplayName(action.displayName));

        yield put(settingsChangeSuccess(response.data.updateSetting));
      } catch (e) {
        yield put(
          settingsChangeFail({
            settings: action,
            error: e.message,
          })
        );
      }
      break;
    }

    case USERNAME_CHANGE: {
      try {
        const response = yield call(updateMe, {
          name: action.name,
        });

        if (response.errors?.length) {
          throw new Error(
            response.errors[0].code ?? response.errors[0].extensions?.code
          );
        }

        yield put(
          promptToast(
            'success',
            window.APP_GLOBALS.t('account', 'settings.saved')
          )
        );
        yield put(settingsChangeSuccess(response.data.updateMe));
      } catch (e) {
        yield put(
          settingsChangeFail({
            settings: action,
            error: e.message,
          })
        );
      }
      break;
    }
    default: {
      break;
    }
  }
}

function* handleUpdateSubscriptionSetting(action) {
  yield put(updateSubscriptionSetting(action.id, action.subscribed));

  const response = yield call(graphql, updateSubscriptionSettingMutation, {
    id: action.id,
    subscribed: action.subscribed,
  });

  if (!response.errors) {
    yield put(
      promptToast('success', window.APP_GLOBALS.t('account', 'settings.saved'))
    );
  }
}

function* mySaga() {
  yield takeLatest(
    [
      SETTINGS_CHANGE_SUCCESS,
      USERNAME_CHANGE,
      DISPLAY_NAME_CHANGE,
      EMAIL_CHANGE,
      PASSWORD_CHANGE,
    ],
    handleSettingsAction
  );
  yield takeEvery(
    UPDATE_SUBSCRIPTION_SETTING_REQUEST,
    handleUpdateSubscriptionSetting
  );
}

export default mySaga;
